import {
  Button,
  Card,
  Col,
  Descriptions,
  Drawer,
  Dropdown,
  Modal,
  PageHeader,
  Progress,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import React, { useContext, useState, useEffect } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { professionalAction } from "../../../_actions";
import { ViewGunaDetails } from "../../viewGunaDetails/viewGunaDetails";
import { ImageView } from "../../image/imageView";
import moment from "moment";
import { RoleByService } from "../../../_services/roleby.service";
import * as XLSX from "xlsx-js-style";
import _ from "lodash";

export const NoticeTable = ({
  data,
  loading,
  onViewAccusedForm,
  professionals,
  user,
  dispatch,
  showList,
  total,
  startDate,
  endDate,
}) => {
  const [aropiInfoDrawer, setAropiInfoDrawer] = useState(false);
  const [criminalList, setCriminalList] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState();
  const [searchText, setSearchText] = useState("");
  const [searchInput, setsearchInput] = useState();
  const { language, setLanguage, t } = useContext(LanguageContext);
  const [showGunaDetails, setshowGunaDetails] = useState(false);
  const [gunaLoading, setGunaLoading] = useState(false);
  const [showPreventiveDetails, setShowPreventiveDetails] = useState(false);
  const [preventiveLoading, setPreventiveLoading] = useState(false);
  const [viewNotice, setNotice] = useState();
  const [showNotice, setShowNotice] = useState(false);
  const [noticeCount, setNoticeCount] = useState(false);
  const [noticeData, setNoticeData] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [photoFilterStatus, setPhotoFilterStatus] = useState(undefined);
  const [info, setInfo] = useState();

  const openNoticeCount = () => {
    setNoticeCount(true);
  };
  const closeNoticeCount = () => {
    setNoticeCount(false);
    setNoticeData([]);
  };
  const closeNoticeView = () => {
    setShowNotice(false);
    setNotice();
  };

  const noticeList = (districtId) => {
    setLoadingList(true);
    const temp = {
      city: user.cityId,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      districtId: [districtId],
    };
    RoleByService.noticeListByRole(temp).then((res) => {
      res &&
        res.text().then((criminalList1) => {
          let criminal = JSON.parse(criminalList1);
          let list = criminal.results;

          setNoticeData(list);
          setLoadingList(false);
        });
    });
  };
  const noticeView = () => {
    setShowNotice(!showNotice);
  };

  const getCityName = (id) => {
    const { pc_cities } = professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  const download_csv = (info) => {
    const report_name = info;
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;
    const ReportTitle = info;

    const arrData =
      Array.isArray(noticeData) &&
      noticeData.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("notice_police")]: data?.action_taken_police_station || "-",
        [t("notice_date")]: data?.notice_date || "-",

        [t("name")]: data?.name || "-",
        [t("accused_police_station")]: data.districtName,
        [t("notice_type")]:
          data.type === "BNS_35_3"
            ? "भारतीय नागरिक सुरक्षा संहिता २०२३ चे कलम ३५(३) प्रमाणे"
            : data.type === "CrPC_41A"
            ? "फौजदारी प्रक्रिया संहिता ४१(अ) प्रमाणे"
            : "-",
        [t("total_crimes")]: data.totalCrimeCount,
        [`${t("cr.no")} / ${t(
          "police_station_of_crime"
        )}`]: `${data.cr_no}/${data.guna_districtName}`,
      }));

    if (!arrData.length) return;
    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    // ===================== SHEET =====================
    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    const cityName = getCityName(user?.cityId || "");

    const headerData = cityName;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${moment(startDate).format("DD-MM-YYYY") || "-"} To ${
        moment(endDate).format("DD-MM-YYYY") || "-"
      }`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  const handleViewForm = (data) => {
    onViewAccusedForm(data);
  };

  const showGunaViewModel = () => {
    setshowGunaDetails(true);
  };
  const closeGunaViewModel = () => {
    setshowGunaDetails(false);
  };
  const onGunaForm = (data) => {
    showGunaViewModel();
    if (data) {
      setGunaLoading(true);
      dispatch({
        type: "GET_CRIMINALS_BY_ID_SUCCESS",
        criminalViewList: {},
      });
      dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [id, setId] = useState();

  const openImageModal = (img, id) => {
    setImageOpen(true);
    setSelectedImage(img);
    setId(id);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
  };
  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      gunaLoading &&
      professionals?.criminalViewList &&
      Object.keys(professionals.criminalViewList).length > 0
    ) {
      setGunaLoading(false);
    }
  }, [professionals?.criminalViewList]);

  const columnTotals = data.reduce(
    (acc, row) => {
      acc.count += Number(row.count || 0);

      return acc;
    },
    {
      count: 0,
    }
  );

  const columnHeader = (label, total) => (
    <div style={{ textAlign: "center" }}>
      <div>{label}</div>
      <div style={{ fontSize: 12, color: "rgb(155, 0, 0)", fontWeight: 600 }}>
        (एकूण - {total})
      </div>
    </div>
  );
  const dataList = {
    columns: [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title: t("notice_police"),
        dataIndex: "action_taken_police_station",
        key: "action_taken_police_station",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
        render: (text, record) => (
          <div>{record?.action_taken_police_station}</div>
        ),
      },
      {
        title: t("notice_date"),
        dataIndex: "type",
        key: "type",
        render: (text, record) => {
          const notice_date = record.notice_date ? record.notice_date : "-";
          return (
            <div>
              <span>{notice_date}</span>
            </div>
          );
        },
      },
      // {
      //   title: "नोटीस प्रकार/दिनांक",
      //   dataIndex: "type",
      //   key: "type",
      //   render: (text, record) => {
      //     const type = record.type ? record.type : "-";
      //     const notice_date = record.notice_date ? record.notice_date : "-";
      //     return (
      //       <div className="action-links-responsive">
      //         <Button
      //           type="text"
      //           size="small"
      //           className="action-link update-link"
      //           onClick={() => {
      //             noticeView();
      //             setNotice(record);
      //           }}
      //         >
      //           <span style={{ fontWeight: "bold" }}>{type}</span>
      //           <span> - </span>
      //           <span>{notice_date}</span>
      //         </Button>
      //       </div>
      //     );
      //   },
      // },

      {
        title: t("name"),
        dataIndex: "नाव",
        key: "नाव",

        render: (text) => <div>{text}</div>,
      },
      {
        title: t("accused_police_station"),
        dataIndex: "crime_districtName",
        key: "crime_districtName",
        render: (text, record) => <div>{record?.crime_districtName}</div>,
      },
      {
        title: t("notice_type"),
        dataIndex: "type",
        key: "type",
        render: (text, record) => {
          const type = record.type ? record.type : "-";
          const notice_date = record.notice_date ? record.notice_date : "-";
          return (
            <div className="action-links-responsive">
              <Button
                type="text"
                size="small"
                className="action-link update-link"
                onClick={() => {
                  noticeView();
                  setNotice(record);
                }}
              >
                <span style={{ fontWeight: "bold" }}>{type}</span>
              </Button>
            </div>
          );
        },
      },
      {
        title: t("total_crimes"),
        key: "totalCrimeCount",
        dataIndex: "totalCrimeCount",
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              onClick={() => onGunaForm(record.masterId)}
            >
              {record.totalCrimeCount}
            </Button>
          </div>
        ),
      },
      {
        title: `${t("cr.no")} / ${t("police_station_of_crime")}`,
        dataIndex: "cr_no",
        key: "cr_no",
        render: (text, record) => {
          const crNo = record.cr_no ? record.cr_no : "-";
          const districtName = record.guna_districtName
            ? record.guna_districtName
            : "-";
          return (
            <div>
              <span style={{ fontWeight: "bold" }}>{crNo}</span>
              <span> - </span>
              <span>{districtName}</span>
            </div>
          );
        },
      },
    ],

    rows: noticeCount
      ? noticeData.map((item, index) => ({
          key: index,
          type: item.type,
          srNo: index + 1,
          नाव: (
            <p title={item?.id}>{item.basci_name ? item.basci_name : "-"}</p>
          ),
          action_taken_police_station: item?.action_taken_police_station,
          basci_name: item?.basci_name,
          name: item?.name,
          aaropi_aadhar_number: item?.aaropi_aadhar_number,
          aaropi_address: item?.aaropi_address,
          aaropi_number: item?.aaropi_number,
          aaropi_photo: item?.aaropi_photo,
          aaropi_pincode: item?.aaropi_pincode,
          crime_districtName: item.districtName || "-",
          totalCrimeCount: item.totalCrimeCount || "-",
          cr_no: item.cr_no || "-",
          guna_districtName: item.guna_districtName || "-",
          notice_date: moment(item.notice_date).format("DD/MM/YYYY"),
          type:
            item.type === "BNS_35_3"
              ? "भारतीय नागरिक सुरक्षा संहिता २०२३ चे कलम ३५(३) प्रमाणे"
              : item.type === "CrPC_41A"
              ? "फौजदारी प्रक्रिया संहिता ४१(अ) प्रमाणे"
              : "-",
          photo: item.aaropi_photo ? item.aaropi_photo : null,
          masterId: item.masterId || "-",
          document: item.document || "-",
        }))
      : data.map((item, index) => ({
          key: index,
          type: item.type,
          srNo: index + 1,
          नाव: (
            <p title={item?.masterId}>
              {item.basci_name ? item.basci_name : "-"}
            </p>
          ),
          action_taken_police_station: item?.action_taken_police_station,
          basci_name: item?.basci_name,
          name: item?.name,
          aaropi_aadhar_number: item?.aaropi_aadhar_number,
          aaropi_address: item?.aaropi_address,
          aaropi_number: item?.aaropi_number,
          aaropi_photo: item?.aaropi_photo,
          aaropi_pincode: item?.aaropi_pincode,
          crime_districtName: item.districtName || "-",
          totalCrimeCount: item.totalCrimeCount || "-",
          cr_no: item.cr_no || "-",
          guna_districtName: item.guna_districtName || "-",
          notice_date: moment(item.notice_date).format("DD/MM/YYYY"),
          type:
            item.type === "BNS_35_3"
              ? "भारतीय नागरिक सुरक्षा संहिता २०२३ चे कलम ३५(३) प्रमाणे"
              : item.type === "CrPC_41A"
              ? "फौजदारी प्रक्रिया संहिता ४१(अ) प्रमाणे"
              : "-",
          photo: item.aaropi_photo ? item.aaropi_photo : null,
          masterId: item.masterId || "-",
          document: item.document,
          mobile_no: item.mobile_no,
          aaropi_aadhar_number: item?.aaropi_aadhar_number,
          aaropi_address: item?.aaropi_address,
          aaropi_pincode: item?.aaropi_pincode,
        })),
  };

  dataList.columns.push({
    ...{
      title: t("photo"),
      key: "photo",
      filters: [
        {
          text: "फोटो",
          value: 1,
        },
        {
          text: "नाही",
          value: null,
        },
      ],
      filters: [
        {
          text: t("photo"), // has photo
          value: "has",
        },
        {
          text: t("no"), // no photo
          value: "none",
        },
      ],
      onFilter: (value, record) => {
        setPhotoFilterStatus(value);
        if (value === "has") {
          return !!record.photo; // true if photo exists
        }
        if (value === "none") {
          return !record.photo; // true if no photo
        }
        setPhotoFilterStatus(undefined);
        return true;
      },
      render: (text, record) => ({
        props: { style: { color: "#000" } },
        children: (
          <Space size="middle">
            {record.photo ? (
              <img
                style={{ width: 50, height: 50, cursor: "pointer" }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  record.photo
                }
                onClick={() => openImageModal(record.photo, record.masterId)}
                alt="photo"
              />
            ) : (
              "नाही"
            )}
          </Space>
        ),
      }),
    },
  });

  dataList.columns.push({
    ...{
      title: t("action"),
      key: "action",
      onHeaderCell: () => ({
        style: {
          color: "#000",
          fontWeight: "bold",
        },
      }),
      render: (text, record) => ({
        props: { style: { color: "#000" } },
        children: (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                handleViewForm(record?.masterId);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      }),
    },
  });

  const dataCount = {
    columns: [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title: "आरोपीचे पो. स्टे",
        dataIndex: "districtName",
        key: "districtName",
        render: (text, record) => <div>{record?.districtName}</div>,
      },
      {
        title: columnHeader(t("total"), columnTotals.count),
        dataIndex: "count",
        key: "count",
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              disabled={record.count === 0}
              onClick={() => {
                openNoticeCount();
                noticeList(record.district);
                setInfo(record);
              }}
            >
              {record?.count}
            </Button>
          </div>
        ),
      },
    ],

    rows: data.map((item, index) => ({
      key: index,
      count: item?.count,
      districtName: item?.districtName,
      district: item?.district,
      srNo: index + 1,
    })),
  };
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setPagination({
      ...pagination,
      pageSize: pagination.pageSize,
    });
  };
  console.log("viewNotice", viewNotice);

  const filteredPhotoCount = (() => {
    // Default: show count of rows that have a valid photo
    if (photoFilterStatus === undefined) {
      return dataList.rows.filter(
        (res) => res.aaropi_photo !== "" && res.aaropi_photo !== null
      ).length;
    }

    if (photoFilterStatus === "has") {
      // Count rows that HAVE photo
      return dataList.rows.filter(
        (res) => res.aaropi_photo !== "" && res.aaropi_photo !== null
      ).length;
    }

    // photoFilterStatus === "none"
    return dataList.rows.filter(
      (res) => res.aaropi_photo === "" || res.aaropi_photo === null
    ).length;
  })();

  console.log("filteredPhotoCount", filteredPhotoCount);

  const boxStyle = {
    padding: "4px 12px",
    background: "#fff",
    borderRadius: "4px",
    border: "1px solid #d9d9d9",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "10px",
    marginTop: "10px",
  };

  const calculateProgress = () => {
    const fields = [
      { label: "फोटो", key: "aaropi_photo" },
      { label: "मोबाईल", key: "aaropi_number" },
      
      { label: "आधार क्रमांक", key: "aaropi_aadhar_number" },
    ];

    if (!Array.isArray(data) || data.length === 0) {
      return { fields, progressMap: {}, totalPercent: 0 };
    }

    let progressMap = {};
    let totalCompleted = 0;
    let totalFields = data.length * fields.length;

    fields.forEach((field) => {
      const completedCount = data.filter((d) => d?.[field.key]).length;
      const percent = Math.round((completedCount / data.length) * 100);

      progressMap[field.key] = {
        label: field.label,
        completedCount,
        percent,
      };

      totalCompleted += completedCount;
    });

    const totalPercent = Math.round((totalCompleted / totalFields) * 100);

    return { fields, progressMap, totalPercent };
  };

  const renderDropdown = () => {
    const { progressMap, totalPercent, fields } = calculateProgress();
    const totalRecords = data?.length || 0;

    const getColor = (percent) => {
      if (percent >= 80) return "#52c41a"; // green
      if (percent >= 40) return "#faad14"; // orange
      return "#ff4d4f"; // red
    };

    return (
      <div className="profile-progress-panel animated-panel">
        <div className="panel-header">नोटीस रजिस्टर</div>

        {/* TOTAL */}
        <div className="progress-row total-row zoom-in">
          <div className="progress-label">
            <span className="total-text">
              एकूण (
              {Object.values(progressMap).reduce(
                (sum, v) => sum + v.completedCount,
                0
              )}{" "}
              / {data?.length})
            </span>
            <span className="percent-text">{totalPercent}%</span>
          </div>

          <Progress
            percent={totalPercent}
            strokeColor={{
              "0%": getColor(totalPercent),
              "100%": getColor(totalPercent),
            }}
            showInfo={false}
            className="animated-progress"
          />
        </div>

        {/* Individual Field Progress */}
        {fields.map((field) => {
          const item = progressMap[field.key];

          return (
            item && (
              <div className="progress-row fade-in" key={field.key}>
                <div className="progress-label">
                  <span>
                    {item.label} ({item.completedCount}/{totalRecords})
                  </span>

                  <span className="percent-text">{item.percent}%</span>
                </div>

                <Progress
                  percent={item.percent}
                  strokeColor={{
                    "0%": getColor(item.percent),
                    "100%": getColor(item.percent),
                  }}
                  showInfo={false}
                  className="animated-progress"
                />
              </div>
            )
          );
        })}
      </div>
    );
  };

  return (
    <div style={{ marginBottom: "10px", padding: "12px" }}>
      <div
        style={{
          marginTop: 10,
          marginBottom: 10,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="stats-wrapper">
          <div className="stats-card stats-accused">
            <span className="stats-text">
              {t("total")}: {total > 0 ? total : "0"}
            </span>
          </div>

          <div className="stats-card stats-photo">
            <span className="stats-text">
              {t("total_photo_count")}: {filteredPhotoCount || 0}
            </span>
          </div>
        </div>

        {showList === "list" && (
          <Dropdown
            overlay={renderDropdown()}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Button type="primary" className="stats-card">
              View Progress
            </Button>
          </Dropdown>
        )}
      </div>

      {/* Filtered Photo Count */}

      {showList === "list" && (
        <Table
          bordered
          loading={loading}
          scroll={{ x: "max-content" }}
          columns={dataList.columns}
          dataSource={dataList.rows}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
          }}
          onChange={handleTableChange}
          rowClassName={() => "govt-table-row"}
        />
      )}
      {showList === "count" && (
        <Table
          bordered
          loading={loading}
          scroll={{ x: "max-content" }}
          columns={dataCount.columns}
          dataSource={dataCount.rows}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
          }}
          onChange={handleTableChange}
          rowClassName={() => "govt-table-row"}
        />
      )}

      {imageOpen && (
        <ImageView
          imageOpen={imageOpen}
          imageUrl={
            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" + selectedImage
          }
          onClose={closeImageModal}
          id={id}
        />
      )}
      <Modal
        title={t("crime_information")}
        top
        visible={showGunaDetails}
        onOk={closeGunaViewModel}
        onCancel={closeGunaViewModel}
        width={95 + "%"}
      >
        <ViewGunaDetails
          pc_crimetitles={professionals?.pc_crimetitles}
          dataStates={
            Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
            professionals?.criminalViewList?.gunhaInfor.length > 0
              ? professionals?.criminalViewList?.gunhaInfor
              : []
          }
          address={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].address
              : ""
          }
          name={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          loading={gunaLoading}
          user_details={user}
          masterId={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].id
              : ""
          }
          closeGunaViewModel={closeGunaViewModel}
        ></ViewGunaDetails>
      </Modal>
      <Drawer
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#fff",
              background: "#1890ff",
              margin: "-24px -24px 24px -24px",
              padding: "16px 24px",
            }}
          >
            <div>
              <p style={{ margin: 0, fontSize: 18, fontWeight: "bold" }}>
                {viewNotice?.basci_name || "अफताब शफी पटनी"}
              </p>
              <p style={{ margin: 0, fontSize: 14 }}>
                नोटीस दिनांक: {viewNotice?.notice_date}
              </p>
            </div>
            {viewNotice?.document && (
              <Button
                type="link"
                icon={<DownloadOutlined />}
                style={{ background: "#fff", color: "#1890ff" }}
                href={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  viewNotice?.document
                }
              >
                PDF Download
              </Button>
            )}
          </div>
        }
        width={800}
        maskClosable={false}
        closable={false}
        onClose={closeNoticeView}
        visible={showNotice}
        footer={
          <div style={{ textAlign: "right" }}>
            <div
              className="steps-action"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <Button onClick={closeNoticeView} style={{ marginRight: 8 }}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        }
      >
        {viewNotice?.photo && (
          <img
            style={{
              width: "150px",
              height: "150px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "1px solid #d9d9d9",
              marginBottom: "10px",
            }}
            src={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              viewNotice?.photo
            }
          />
        )}

        {/* Notice Type */}
        <Card
          title={<div style={{ fontWeight: "bold" }}>नोटीस संबंधित माहिती</div>}
          bordered={false}
          style={{ marginBottom: 16, border: "1px solid #d9d9d9" }}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="कारवाई करणारे पो. स्टे.:">
                  {viewNotice?.action_taken_police_station || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="नोटीस चा प्रकार निवडा">
                  <b>{viewNotice?.type}</b>
                </Descriptions.Item>

                <Descriptions.Item label="नोटीस दिनांक:">
                  {viewNotice?.notice_date}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </Card>

        {/* Officer Details */}
        <Card
          title={
            <div style={{ fontWeight: "bold" }}>अधिकारी / अंमलदार माहिती</div>
          }
          bordered={false}
          style={{ marginBottom: 16, border: "1px solid #d9d9d9" }}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="नाव">
                  {viewNotice?.name || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="मोबाईल क्रमांक">
                  {viewNotice?.mobile_no || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </Card>

        {/* Accused Details */}
        <Card
          title={<div style={{ fontWeight: "bold" }}>आरोपीची माहिती</div>}
          bordered={false}
          style={{ marginBottom: 16, border: "1px solid #d9d9d9" }}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="आरोपीचा आधार क्रमांक">
                  {viewNotice?.aaropi_aadhar_number || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="आरोपीचा मोबाइल क्रमांक">
                  {viewNotice?.aaropi_number || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="आरोपीचा पत्ता">
                  {viewNotice?.aaropi_address || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="पिनकोड">
                  {viewNotice?.aaropi_pincode || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </Card>
      </Drawer>
      <Drawer
        title={
          <div
            style={{
              position: "relative",
              height: 28,
              display: "flex",
              alignItems: "center",
            }}
          >
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              नोटीस यादी
            </span>

            <Typography.Text
              strong
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                color: "#1d39c4",
                fontSize: 16,
                whiteSpace: "nowrap",
              }}
            >
              {t("police_station")} : {info?.districtName}
            </Typography.Text>
          </div>
        }
        width={900}
        maskClosable={false}
        closable={false}
        onClose={closeNoticeCount}
        visible={noticeCount}
        footer={
          <div style={{ textAlign: "right" }}>
            <div
              className="steps-action"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <Button
                  danger
                  onClick={closeNoticeCount}
                  style={{ marginRight: 8 }}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        }
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          {/* LEFT SIDE DATE */}
          <span>
            {moment(startDate).format("DD-MM-YYYY")}
            {" To "}
            {moment(endDate).format("DD-MM-YYYY")}
          </span>

          {/* RIGHT SIDE BUTTON */}
          <Button
            type="primary"
            size="small"
            onClick={() => {
              download_csv("नोटीस यादी");
            }}
          >
            Download Excel
          </Button>
        </div>
        <Table
          bordered
          loading={loadingList}
          scroll={{ x: "max-content" }}
          columns={dataList.columns}
          dataSource={dataList.rows}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
          }}
          onChange={handleTableChange}
          rowClassName={() => "govt-table-row"}
        />
      </Drawer>
    </div>
  );
};
